class QualitechNavigation extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('.qt-nav-toggle');
    this.menu = this.querySelector('.qt-nav-menu');
    this.details = [...this.querySelectorAll('.qt-menu-details')];
    this.desktop = window.matchMedia('(min-width: 990px)');
    this.hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.toggleButton.addEventListener('click', () => this.hasAttribute('open') ? this.close() : this.openMobile());
    this.querySelector('.qt-nav-close').addEventListener('click', () => this.close());
    this.details.forEach(details => {
      details.querySelector('summary').addEventListener('click', () => { clearTimeout(this.enterTimer); clearTimeout(this.leaveTimer); });
      details.addEventListener('toggle', () => {
        if (details.open) this.details.filter(other => other !== details).forEach(other => other.open = false);
      });
      details.addEventListener('pointerenter', () => {
        if (!this.desktop.matches || !this.hoverDevice.matches) return;
        clearTimeout(this.leaveTimer);
        this.enterTimer = setTimeout(() => details.open = true, 140);
      });
      details.addEventListener('pointerleave', () => {
        clearTimeout(this.enterTimer);
        if (this.desktop.matches && this.hoverDevice.matches) this.leaveTimer = setTimeout(() => details.open = false, 180);
      });
    });
    this.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const current = this.details.find(details => details.open);
      if (current) { current.open = false; current.querySelector('summary').focus(); }
      else if (this.hasAttribute('open')) this.close();
    });
    document.addEventListener('pointerdown', event => {
      if (!this.contains(event.target) && this.desktop.matches) this.details.forEach(details => details.open = false);
    });
    this.desktop.addEventListener('change', () => this.close(false));
  }
  openMobile() {
    this.style.setProperty('--qt-nav-top', `${this.closest('.header-wrapper').getBoundingClientRect().bottom}px`);
    this.setAttribute('open', '');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('qt-navigation-open');
    trapFocus(this.menu, this.querySelector('.qt-nav-close'));
  }
  close(restoreFocus = true) {
    this.removeAttribute('open');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('qt-navigation-open');
    this.details.forEach(details => details.open = false);
    removeTrapFocus(restoreFocus ? this.toggleButton : undefined);
  }
}
if (!customElements.get('qt-navigation')) customElements.define('qt-navigation', QualitechNavigation);
document.addEventListener('click', event => {
  const button = event.target.closest('[data-qt-view]');
  if (!button) return;
  const root = button.closest('.shopify-section');
  root.classList.toggle('qt-list-view', button.dataset.qtView === 'list');
  root.querySelectorAll('[data-qt-view]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
});
